import { print } from 'graphql';

import { findByAliasCourseQuery, findByIdCourseQuery, findOneCourseQuery } from '~/shared/graphql-queries';
import createOneCourseMutation from '~/shared/graphql-queries/courses/create-one-course-mutation';
import findCourseInfoByIdsQuery from '~/shared/graphql-queries/courses/find-course-info-by-ids-query';
import removeByIdCourseMutation from '~/shared/graphql-queries/courses/remove-by-id-course-mutation';
import updateByIdCourseMutation from '~/shared/graphql-queries/courses/update-by-id-course-mutation';
import type { BuilderType } from '~/types';

type FindOneCourseArgs = Readonly<{
  isFreeCourse?: boolean;
  alias?: string;
}>;

type FindCourseInfoByIdsArgs = Readonly<{
  ids?: string[];
}>;

type FindByAliasCourseArgs = Readonly<{
  alias?: string;
}>;

type FindByIdCourseArgs = Readonly<{
  _id?: string;
}>;

type RemoveByIdCourseArgs = Readonly<{
  _id?: string;
}>;

type UpdateByIdCourseArgs = Readonly<{
  _id?: string;
  record?: unknown;
}>;

type CreateOneCourseArgs = Readonly<{
  record?: unknown;
}>;

export const coursesTagTypes = [] as const;

export const getCoursesQuery = (builder: BuilderType) => {
  return {
    findOneCourse: builder.query<unknown, FindOneCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findOneCourseQuery),
          variables: {
            isFreeCourse: args?.isFreeCourse,
            alias: args?.alias,
          },
        }),
      }),
    }),

    findCourseInfoByIds: builder.query<unknown, FindCourseInfoByIdsArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findCourseInfoByIdsQuery),
          variables: {
            ids: args?.ids,
          },
        }),
      }),
    }),

    findByAliasCourseQuery: builder.query<unknown, FindByAliasCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findByAliasCourseQuery),
          variables: {
            alias: args?.alias,
          },
        }),
      }),
    }),

    findByIdCourse: builder.query<unknown, FindByIdCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findByIdCourseQuery),
          variables: {
            _id: args?._id,
          },
        }),
      }),
    }),

    removeByIdCourse: builder.mutation<unknown, RemoveByIdCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(removeByIdCourseMutation),
          variables: {
            _id: args?._id,
          },
        }),
      }),
    }),

    updateByIdCourse: builder.mutation<unknown, UpdateByIdCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(updateByIdCourseMutation),
          variables: {
            _id: args?._id,
            record: args?.record,
          },
        }),
      }),
    }),

    createOneCourse: builder.mutation<unknown, CreateOneCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(createOneCourseMutation),
          variables: {
            record: args?.record,
          },
        }),
      }),
    }),
  };
};
